export function assertProp(
  value: any,
  propName: string,
  componentName: string,
): asserts value {
  if (process.env.NODE_ENV !== 'production') {
    if (value == null) {
      throw new Error(
        `${propName} prop was not passed, make sure to propagate all props to ${componentName}`,
      );
    }
  }
}
